document.addEventListener("DOMContentLoaded", function () {
  // Check if the countdown element exists
  var countdownElement = document.getElementById("countdown");
  if (!countdownElement) {
    console.error("Countdown element not found");
    return; // Exit the function if element is not found
  }

  // Set the date we're counting down to
  var countDownDate = new Date("April 30, 2024 00:00:00").getTime();

  // Update the countdown every 1 second
  var x = setInterval(function () {
    // Get the current date and time
    var now = new Date().getTime();

    // Calculate the remaining time
    var distance = countDownDate - now;

    // Calculate days, hours, minutes, and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the countdown
    countdownElement.innerHTML =
      days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

    // If the countdown is over, display a message
    if (distance < 0) {
      clearInterval(x);
      countdownElement.innerHTML = "EXPIRED";
    }
  }, 1000);
});
